// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.marginTop25 {
  margin-top: 25px;
}

.marginLeft10 {
  margin-left: 10px;
}

.updatePageMarginLeft200 {
    margin-left: 200px;
}

.profileInfoDivFeed {
    position: absolute;
    margin: 7% 0 0 15%;
}

.profileInfoDivFeedIpad {
    position: absolute;
    margin: 7% 0 0 7%;
}

.headerWrapperDiv {
    height: 55px;  
    padding: 0 30px 0 30px;
    border-radius: 27.5px;
    background-color: #f8f8fa;
    align-items:center;
    margin-left: 400px;
    margin-top: -55px;
    display: flex;
}

.displayFlex {
    display: flex;
}

.previousInactive {
    cursor: pointer;
    margin-right: 20px;
}

.floatRight {
    float: right;
}

`, "",{"version":3,"sources":["webpack://./src/components/styles/Feed.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".marginTop25 {\n  margin-top: 25px;\n}\n\n.marginLeft10 {\n  margin-left: 10px;\n}\n\n.updatePageMarginLeft200 {\n    margin-left: 200px;\n}\n\n.profileInfoDivFeed {\n    position: absolute;\n    margin: 7% 0 0 15%;\n}\n\n.profileInfoDivFeedIpad {\n    position: absolute;\n    margin: 7% 0 0 7%;\n}\n\n.headerWrapperDiv {\n    height: 55px;  \n    padding: 0 30px 0 30px;\n    border-radius: 27.5px;\n    background-color: #f8f8fa;\n    align-items:center;\n    margin-left: 400px;\n    margin-top: -55px;\n    display: flex;\n}\n\n.displayFlex {\n    display: flex;\n}\n\n.previousInactive {\n    cursor: pointer;\n    margin-right: 20px;\n}\n\n.floatRight {\n    float: right;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
